<template>
  <div class="divide-y">
    <div class="p-4">
      <nav class="space-y-1" aria-label="Sidebar">
        <a
          v-for="tagCategory in tagCategories"
          :key="tagCategory.slug"
          role="button"
          class="flex items-center px-3 py-2 text-sm font-medium rounded-md"
          :class="[
            isCurrentTagCategory(tagCategory)
              ? 'bg-gray-100 text-gray-900'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
          ]"
          @click.prevent="switchTagCategory(tagCategory)"
        >
          <span class="truncate">
            {{ tagCategory.name }}
          </span>
        </a>
      </nav>
    </div>
    <div class="p-4">
      <TagCategoryCreateAction @tag-category-created="onTagCategoryCreated" />
    </div>
  </div>
</template>

<script>
import TagCategoryCreateAction from './TagCategoryCreateAction.vue';

export default {
  components: {
    TagCategoryCreateAction,
  },
  props: {
    currentTagCategory: {
      type: Object,
      default: null,
    },
    tagCategories: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isCurrentTagCategory(tagCategory) {
      return tagCategory.id === this.currentTagCategory?.id;
    },
    switchTagCategory(newTagCategory) {
      if (this.isCurrentTagCategory(newTagCategory)) {
        return;
      }

      this.$emit('switch', newTagCategory);
    },
    onTagCategoryCreated(newTagCategory) {
      this.$emit('tag-category-created', newTagCategory);
    },
  },
};
</script>
